import React from 'react';
import { Modal } from 'react-bootstrap';

import Form from './Form';

export default function ModalForm({ show, template, onClose }) {
  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Policy Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form template={template} onClose={onClose} />
      </Modal.Body>
    </Modal>
  );
}
